import { useState, useEffect } from 'react';
import '@fontsource/work-sans/400.css';
import '@fontsource/work-sans/600.css';
import '@fontsource/work-sans/700.css';
import RSSurvey from './components/RSSurvey';
import axios from 'axios';
import ErrorPage from './components/ErrorPage';
import ReactGA from 'react-ga4';
import { onLink } from './handlers';
import CMPSurvey from './altApps/CareerMatchPromo/CMPSurvey';

function App() {
  ReactGA.initialize([
    {
      trackingId: 'G-5KZ373JDL7',
    },
  ]);
  const [data, setData] = useState({ fetched: [] });
  const [userID, setUserID] = useState(0);
  const [error, setError] = useState('');
  /***
   const url = 'https://appstage.resumescripter.com/wp-json/rsworks/v1/sectionQuestions'
   const uid = 6945;
   setUserID(uid);
   const request = { userID: uid };
     ****************
   const url = '/wp-json/rsworks/v1/sectionQuestions';
   const uid = window.userID;
   setUserID(uid);
   const request = { userID: uid };
   ***/
  useEffect(() => {
    const fetchData = async () => {
      const appType = window.appType;
      let url = '/wp-json/rsworks/v1/sectionQuestions';
      let request = { };
      if(appType === 'int') {
        url = '/wp-json/rsworks/v1/interviewPromo';
      } else {
        if(appType === 'city') {
          url = '/wp-json/rsworks/v1/interviewCityPromo';

        } else {
          if (appType === 'cm') {
            url = '/wp-json/rsworks/v1/careerMatchPromo';
          } else {
            if (appType === 'mi') {
              url = '/wp-json/rsworks/v1/mockInterviewPromo';
            } else {
              const uid = window.userID;
              setUserID(uid);
              request = { userID: uid };
            }
          }
        }
      }
      try {
        const result = await axios.post(url, request);
        setData({ fetched: JSON.parse(result.data) });
        setError(null);
      } catch (err) {
        setError(err);
      }
    };
    fetchData();
  }, []);

  //the data.fetched.member.length results in a never-ending spinner
  //if they come to the app incorrectly.  Need better error message?
  if (data.fetched.length !== 0 && data.fetched.member.length !== 0) {
      const appType = window.appType;
      if(appType === 'int' || appType === 'cm' || appType === 'mi' || appType === 'city') {
        return (<CMPSurvey data={data.fetched} appType={appType} />);
      } else {
        return (<RSSurvey data={data.fetched} userID={userID} />);
      }
  } else {
    return (<ErrorPage dataError={error} />);
  }
}

export default App;